const getPathSegments = (pathname) => pathname.split('/').filter(Boolean);

const getSegmentAfter = (segments, key) => {
  const index = segments.indexOf(key);
  return index !== -1 ? segments[index + 1] || null : null;
};

export const revalidateOn = (...segmentKeys) => {
  return ({ currentUrl, nextUrl, defaultShouldRevalidate }) => {
    if (defaultShouldRevalidate) {
      return true;
    }

    const currentSegments = getPathSegments(currentUrl.pathname);
    const nextSegments = getPathSegments(nextUrl.pathname);

    return segmentKeys.some((key) => {
      const currentHasKey = currentSegments.includes(key);
      const nextHasKey = nextSegments.includes(key);

      if (currentHasKey !== nextHasKey) {
        return true;
      }

      const currentValue = getSegmentAfter(currentSegments, key);
      const nextValue = getSegmentAfter(nextSegments, key);

      return currentValue !== nextValue;
    });
  };
};